import { useEquipmentDetailsRouteState } from '@/features/equipment-browser/equipment-details/hooks/use-equipment-details-route-state';
import { useGetEquipmentBrowserConfig } from '@/hooks/query-hooks/gaia-api/equipment-browser';
import { useCurrentFacility } from '@/hooks/use-current-facility';

/** Effective equipment browser view: explicit route view, else config default. */
export const resolveEquipmentViewId = (
  currentViewId: string | undefined,
  defaultView: string | undefined
): string | undefined => {
  return currentViewId ?? defaultView;
};

/** Route view id when set; otherwise equipment browser default view from config. */
export const useResolvedEquipmentViewId = (): string | undefined => {
  const { viewId } = useEquipmentDetailsRouteState();
  const { agentId } = useCurrentFacility();
  const { data: ebConfig } = useGetEquipmentBrowserConfig({ agentId });

  return resolveEquipmentViewId(viewId, ebConfig?.defaultView);
};
